import { render, staticRenderFns } from "./TheLessonView.vue?vue&type=template&id=53825ec0&scoped=true&"
import script from "./TheLessonView.vue?vue&type=script&lang=js&"
export * from "./TheLessonView.vue?vue&type=script&lang=js&"
import style0 from "./TheLessonView.vue?vue&type=style&index=0&id=53825ec0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53825ec0",
  null
  
)

export default component.exports